import {
	EnvironmentOutlined,
	HomeOutlined,
	MailOutlined,
	PhoneOutlined,
} from "@ant-design/icons";
import { Card, Empty, List, Spin, Row, Col, Typography, Divider } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { getClientAddressesByNo } from "../../services/clientAddressService";

const ClientAddressList = ({ clientNo, clientName }) => {
	const [addresses, setAddresses] = useState([]);
	const [loading, setLoading] = useState(false);
	const { Text } = Typography;

	const loadClientAddresses = useCallback(async () => {
		try {
			setLoading(true);
			const clientAddresses = await getClientAddressesByNo(clientNo);
			setAddresses(clientAddresses);
		} catch (error) {
			console.error("Error al cargar direcciones del cliente:", error);
			window.messageApi.error("Error al cargar direcciones del cliente");
			setAddresses([]);
		} finally {
			setLoading(false);
		}
	}, [clientNo]);

	useEffect(() => {
		if (clientNo) {
			loadClientAddresses();
		} else {
			setAddresses([]);
		}
	}, [clientNo, loadClientAddresses]);

	if (loading) {
		return <Spin size="large" />;
	}

	if (!clientNo) {
		return (
			<>
				<Text strong>{`Direcciones de ${clientName || clientNo}`}</Text>
				<Divider />
				<Empty description="Seleccione un cliente para ver sus direcciones" />
			</>
		);
	}

	if (addresses.length === 0) {
		return (
			<>
				<Text strong>{`Direcciones de ${clientName || clientNo}`}</Text>
				<Divider />
				<Empty description="Este cliente no tiene direcciones registradas" />
			</>
		);
	}

	return (
		<>
			<Text strong>{`Direcciones de ${clientName || clientNo}`}</Text>
			<Divider />
			<List
				grid={{
					gutter: 16,
					xs: 1,
					sm: 1,
					md: 1,
					lg: 1,
					xl: 1,
					xxl: 1,
				}}
				dataSource={addresses}
				renderItem={(address) => (
					<List.Item>
						<Card
							size="small"
							title={
								<div style={{ display: "flex", alignItems: "center" }}>
									<HomeOutlined style={{ marginRight: 8 }} />
									{address.Name}
								</div>
							}
							extra={
								<span style={{ fontSize: "12px", color: "#666" }}>
									{address.Code}
								</span>
							}
						>
							<Row gutter={[16, 8]}>
								<Col xs={24} sm={12}>
									<Text strong>
										<EnvironmentOutlined style={{ marginRight: 4 }} />
										Ciudad:
									</Text>{" "}
									<Text>{address.Ciudad || "No especificada"}</Text>
								</Col>

								<Col xs={24} sm={12}>
									<Text strong>
										<EnvironmentOutlined style={{ marginRight: 4 }} />
										Provincia:
									</Text>{" "}
									<Text>{address.Provincia || "No especificada"}</Text>
								</Col>

								{address.Teléfono && (
									<Col xs={24} sm={12}>
										<Text strong>
											<PhoneOutlined style={{ marginRight: 4 }} />
											Teléfono:
										</Text>{" "}
										<Text>{address.Teléfono}</Text>
									</Col>
								)}

								{address.Email && (
									<Col xs={24} sm={12}>
										<Text strong>
											<MailOutlined style={{ marginRight: 4 }} />
											Email:
										</Text>{" "}
										<Text>{address.Email}</Text>
									</Col>
								)}
							</Row>
						</Card>
					</List.Item>
				)}
			/>
			<Divider />
		</>
	);
};

export default ClientAddressList;
